import React from 'react';
import axios from 'axios';
import {
    Form,
    Tab,
    Table,
    Header,
    Segment,
    Button,
    Input,
    Icon,
    Popup,
    Transition,
    Loader,
    Responsive
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { fetchOrganizationalUnits, fetchEntityTypes, fetchMunicipalities, fetchCantons, fetchEntities, fetchCountries, fetchContactTypes } from './Lookups/util';
import { IconHeader, FiltersOnStyle, RightHeaderWithButton } from './util/css';
import LeaseholderFilter from './Leaseholder/LeaseholderFilter';
import LeaseholderContact from './Leaseholder/LeaseholderContactEditable';
import LeaseholderAddress from './Leaseholder/LeaseholderAddressEditable';
import { ADMINISTRATOR, FACULTY_ADMIN, UNIVERSITY_ADMIN, FACULTY, UNIVERSITY, fetchActiveRole, fetchUserOrganizationalUnit } from './util/roles';
import LeaseholderDetails from './Leaseholder/LeaseholderDetails';
import PaginationSegment from './util/PaginationSegment';
import { getTotalNumberOfPages } from './util/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const DEFAULT_NUMBER_OF_ITEMS_PER_PAGE = 10;


class Leaseholder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contactTypes: [],
            municipalities: [],
            cantons: [],
            entities: [],
            countries: [],
            physicalLeaseholders: [],
            legalLeaseholders: [],
            organizationalUnitLeaseholders: [],
            filteredPhysicalLeaseholders: [],
            filteredLegalLeaseholders: [],
            filteredOrganizationalUnitLeaseholders: [],
            organizationalUnits: [],
            entityTypes: [],
            lookups: {
                entityTypes: [],
            },
            physicalEntityName: null,
            physicalEntityLastName: null,
            physicalEntityJMBG: null,
            comment: null,
            physicalEntityId: null,
            physicalEntityOptLock: null,
            legalEntityName: null,
            legalEntityIdNumber: null,
            legalEntityId: null,
            legalEntityOptLock: null,
            organizationalUnitEntity: null,
            entityType: null,
            entityId: null,
            entityOptLock: null,
            organizationalUnitId: null,
            requestMode: null,
            loading: true,
            showFiltersOnButton: false,
            showFilterMode: false,
            contactEditMode: false,
            addressEditMode: false,
            leaseholderData: {
                contacts: [],
                addresses: [],
            },
            details: false,
            leaseholderObject: null,
            organizationalUnitError: false,
            physicalEntityNameError: false,
            physicalEntityLastNameError: false,
            physicalEntityJMBGError: false,
            legalEntityNameError: false,
            legalEntityIdNumberError: false,
            organizationalUnitEntityError: false,

            // For pagination
            activePage: 1,
            totalPages: 1,
            resultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,

            physicalActivePage: 1,
            physicalTotalPages: 1,
            physicalResultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,

            legalActivePage: 1,
            legalTotalPages: 1,
            legalResultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,

            organizationalUnitActivePage: 1,
            organizationalUnitTotalPages: 1,
            organizationalUnitResultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,

            filterRequestData: null,
            loader: true,

            activeIndex: 0
        };
        this.fetchOrganizationalUnits = this.fetchOrganizationalUnits.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.activateEditRequest = this.activateEditRequest.bind(this);
        this.activateAddRequest = this.activateAddRequest.bind(this);
        this.populateValues = this.populateValues.bind(this);
        this.cancelRequest = this.cancelRequest.bind(this);
        this.getLeaseholders = this.getLeaseholders.bind(this);
        this.activateFilter = this.activateFilter.bind(this);
        this.onFilterData = this.onFilterData.bind(this);
        this.filtersOff = this.filtersOff.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.switchContactEditMode = this.switchContactEditMode.bind(this);
        this.switchAddressEditMode = this.switchAddressEditMode.bind(this);
        this.onAddNewAddress = this.onAddNewAddress.bind(this);
        this.onAddNewContact = this.onAddNewContact.bind(this);
        this.switchToDetails = this.switchToDetails.bind(this);
        this.switchToTable = this.switchToTable.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePhysicalPageChange = this.handlePhysicalPageChange.bind(this);
        this.handleLegalPageChange = this.handleLegalPageChange.bind(this);
        this.handleOrganizationalUnitPageChange = this.handleOrganizationalUnitPageChange.bind(this);
        this.handleResultsPerPageChange = this.handleResultsPerPageChange.bind(this);
        this.activateContactRequest = this.activateContactRequest.bind(this);
        this.activateAddressRequest = this.activateAddressRequest.bind(this);
    }
    componentDidMount() {

        this.getUserData();
    }
    fetchLeaseholders(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };
        return axios.post('/assets/leaseholders/paginated/', { ...pagination });
    }
    fetchPhysicalLeaseholders(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        let { filterRequestData } = {
            organizationalUnit: this.state.organizationalUnitId,

            entityType: 1,
            physicalEntity: null,
            legalEntity: null,
        };
        const paginationDTO = {
            page,
            resultsPerPage,
            order: null,
            fieldName: null,
        };

        filterRequestData = { ...filterRequestData, paginationDTO };
        return axios.post('/assets/leaseholders/filter/', { ...filterRequestData });
    }

    fetchAllPhysicalLeaseholders(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        let filterRequestData = {
            organizationalUnit: null,

            entityType: 1,
            physicalEntity: null,
            legalEntity: null,
            paginationDTO: {
                page,
                resultsPerPage,
                order: null,
                fieldName: null,
            }
        };
        return axios.post('/assets/leaseholders/filter/', { ...filterRequestData });
    }

    fetchLegalLeaseholders(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        let { filterRequestData } = {
            organizationalUnit: this.state.organizationalUnitId,

            entityType: 2,
            physicalEntity: null,
            legalEntity: null,
        };
        const paginationDTO = {
            page,
            resultsPerPage,
            order: null,
            fieldName: null,
        };

        filterRequestData = { ...filterRequestData, paginationDTO };
        return axios.post('/assets/leaseholders/filter/', { ...filterRequestData });
    }

    fetchAllLegalLeaseholders(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        let filterRequestData = {
            organizationalUnit: null,

            entityType: 2,
            physicalEntity: null,
            legalEntity: null,
            paginationDTO: {
                page,
                resultsPerPage,
                order: null,
                fieldName: null,
            }
        };
        return axios.post('/assets/leaseholders/filter/', { ...filterRequestData });
    }

    fetchOrganizationalUnitLeaseholders(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        let { filterRequestData } = {
            organizationalUnit: this.state.organizationalUnitId,

            entityType: 3,
            physicalEntity: null,
            legalEntity: null,
        };
        const paginationDTO = {
            page,
            resultsPerPage,
            order: null,
            fieldName: null,
        };

        filterRequestData = { ...filterRequestData, paginationDTO };
        return axios.post('/assets/leaseholders/filter/', { ...filterRequestData });
    }

    fetchAllOrganizationalUnitLeaseholders(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        let filterRequestData = {
            organizationalUnit: null,

            entityType: 3,
            physicalEntity: null,
            legalEntity: null,
            paginationDTO: {
                page,
                resultsPerPage,
                order: null,
                fieldName: null,
            }
        };
        return axios.post('/assets/leaseholders/filter/', { ...filterRequestData });
    }
    fetchAllLeaseholders(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };
        return axios.post('/assets/leaseholders/all/', { ...pagination });
    }
    getUserData() {
        axios.all([fetchActiveRole(), fetchUserOrganizationalUnit()])
            .then(axios.spread((activeRoleRes, userOrganizationalUnitRes) => {
                const activeRole = activeRoleRes.data;
                const organizationalUnitId = userOrganizationalUnitRes.data;

                this.setState({ activeRole, organizationalUnitId });
                this.fetchLookups();
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch data.');
            });
    }
    getLeaseholders(page, resultsPerPage) {
        const { activeRole } = this.state;
        if (activeRole === ADMINISTRATOR || activeRole === UNIVERSITY || activeRole === UNIVERSITY_ADMIN) {
            this.fetchAllLeaseholders(page, resultsPerPage)
                .then(leaseholderRes => {
                    const physicalLeaseholders = leaseholderRes.data.responseList.filter(el => el.entityType.id === 1);
                    const legalLeaseholders = leaseholderRes.data.responseList.filter(el => el.entityType.id === 2);
                    const organizationalUnitLeaseholders = leaseholderRes.data.responseList.filter(el => el.entityType.id === 3);
                    let totalPages = parseInt(leaseholderRes.data.total / resultsPerPage, 10);
                    totalPages += leaseholderRes.data.total % resultsPerPage !== 0 ? 1 : 0;
                    this.setState({
                        physicalLeaseholders,
                        legalLeaseholders,
                        organizationalUnitLeaseholders,
                        totalPages,
                        activePage: page + 1,
                        resultsPerPage,
                        loader:false
                    });
                })
                .catch(err => {
                    toast('Došlo je do greške!');
                    console.log('Failed to fetch data.');
                });
        } else if (activeRole === FACULTY_ADMIN || activeRole === FACULTY) {
            this.fetchLeaseholders(page, resultsPerPage)
                .then(leaseholderRes => {
                    const physicalLeaseholders = leaseholderRes.data.responseList.filter(el => el.entityType.id === 1);
                    const legalLeaseholders = leaseholderRes.data.responseList.filter(el => el.entityType.id === 2);
                    const organizationalUnitLeaseholders = leaseholderRes.data.responseList.filter(el => el.entityType.id === 3);
                    let totalPages = parseInt(leaseholderRes.data.total / resultsPerPage, 10);
                    totalPages += leaseholderRes.data.total % resultsPerPage !== 0 ? 1 : 0;
                    this.setState({
                        physicalLeaseholders,
                        legalLeaseholders,
                        organizationalUnitLeaseholders,
                        totalPages,
                        activePage: page + 1,
                        resultsPerPage,
                        loader: false
                    });
                })
                .catch(err => {
                    toast('Došlo je do greške!');
                    console.log('Failed to fetch data.');
                });
        }
    }
    getFilteredLeaseholders(page, resultsPerPage) {
        let { filterRequestData } = this.state;
        const paginationDTO = { page, resultsPerPage };
        filterRequestData = { ...filterRequestData, paginationDTO };

        axios.post('/assets/leaseholders/filter/', { ...filterRequestData })
            .then(res => {
                const filteredPhysicalLeaseholders = res.data.responseList.filter(el => el.entityType.id === 1);
                const filteredLegalLeaseholders = res.data.responseList.filter(el => el.entityType.id === 2);
                const filteredOrganizationalUnitLeaseholders = res.data.responseList.filter(el => el.entityType.id === 3);
                let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);
                this.setState({
                    filteredPhysicalLeaseholders,
                    filteredLegalLeaseholders,
                    filteredOrganizationalUnitLeaseholders,
                    activePage: page + 1,
                    totalPages,
                    resultsPerPage,
                    filterRequestData,
                    loader:false
                });
            })
            .catch(err => {
                toast('Došlo je do greške!');
                console.log('Error: Failed to fetch filter data\n', err);
            });
    }
    fetchLookups() {
        axios.all([fetchOrganizationalUnits(), fetchEntityTypes(), fetchMunicipalities(), fetchCantons(), fetchEntities(), fetchCountries(), fetchContactTypes()])
            .then(axios.spread((organizationalUnitsRes, entityTypesRes, municipalitiesRes, cantonsRes, entitiesRes, countriesRes, contactTypesRes) => {
                const organizationalUnits = organizationalUnitsRes.data.map((el) => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const municipalities = municipalitiesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name,
                }));
                const cantons = cantonsRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name,
                }));
                const entities = entitiesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name,
                }));
                const countries = countriesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name,
                }));
                const entityTypes = entityTypesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name,
                }));
                const contactTypes = contactTypesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name,
                }));
                const lookups = {
                    entityTypes,
                };
                this.setState({
                    organizationalUnits,
                    municipalities,
                    cantons,
                    entities,
                    countries,
                    entityTypes,
                    contactTypes,
                    lookups,
                    loading: false
                });
                //this.fetchDataForRole();
                this.getOrganizationalUnitLeaseholders();
                this.getLegalLeaseholders();
                this.getPhysicalLeaseholders();
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch data.');
            });
    }
    // fetchDataForRole() {
    //     const { activeRole, resultsPerPage } = this.state;
    //     if (activeRole === ADMINISTRATOR || activeRole === UNIVERSITY || activeRole === UNIVERSITY_ADMIN) {
    //         axios.all([fetchOrganizationalUnits(), this.fetchAllPhysicalLeaseholders(), this.fetchAllLegalLeaseholders(), this.fetchAllOrganizationalUnitLeaseholders()])
    //             .then(axios.spread((organizationalUnitsRes, physicalLeaseholderRes, legalLeaseholdersRes, organizationalUnitLeaseholdersRes) => {
    //                 const organizationalUnits = organizationalUnitsRes.data.map((el) => ({
    //                     ...el, key: el.id, value: el.id, text: el.name
    //                 }));
    //                 const physicalLeaseholders = physicalLeaseholderRes.data.responseList;
    //                 let physicalTotalPages = getTotalNumberOfPages(physicalLeaseholderRes.data.total, resultsPerPage);
    //
    //                 const legalLeaseholders = legalLeaseholdersRes.data.responseList;
    //                 let legalTotalPages = getTotalNumberOfPages(legalLeaseholdersRes.data.total, resultsPerPage);
    //
    //                 const organizationalUnitLeaseholders = organizationalUnitLeaseholdersRes.data.responseList;
    //                 let organizationalUnitTotalPages = getTotalNumberOfPages(organizationalUnitLeaseholdersRes.data.total, resultsPerPage);
    //
    //                 this.setState({
    //                     organizationalUnits,
    //                     physicalLeaseholders,
    //                     physicalTotalPages,
    //
    //                     legalLeaseholders,
    //                     legalTotalPages,
    //
    //                     organizationalUnitLeaseholders,
    //                     organizationalUnitTotalPages,
    //                     loading: false,
    //                 });
    //             }))
    //             .catch((err => {
    //                 this.setState({ error: true, loading: false });
    //                 console.log('Failed to fetch data: ', err);
    //             }));
    //     } else if (activeRole === FACULTY) {
    //         axios.all([this.fetchPhysicalLeaseholders(), this.fetchLegalLeaseholders(), this.fetchOrganizationalUnitLeaseholders()])
    //             .then(axios.spread((physicalLeaseholderRes, legalLeaseholdersRes, organizationalUnitLeaseholdersRes) => {
    //                 const physicalLeaseholders = physicalLeaseholderRes.data.responseList;
    //                 let physicalTotalPages = getTotalNumberOfPages(physicalLeaseholderRes.data.total, resultsPerPage);
    //
    //                 const legalLeaseholders = legalLeaseholdersRes.data.responseList;
    //                 let legalTotalPages = getTotalNumberOfPages(legalLeaseholdersRes.data.total, resultsPerPage);
    //
    //                 const organizationalUnitLeaseholders = organizationalUnitLeaseholdersRes.data.responseList;
    //                 let organizationalUnitTotalPages = getTotalNumberOfPages(organizationalUnitLeaseholdersRes.data.total, resultsPerPage);
    //
    //                 this.setState({
    //                     physicalLeaseholders,
    //                     physicalTotalPages,
    //
    //                     legalLeaseholders,
    //                     legalTotalPages,
    //
    //                     organizationalUnitLeaseholders,
    //                     organizationalUnitTotalPages,
    //                     loading: false,
    //                 });
    //             }))
    //             .catch((err) => {
    //                 console.log('Failed to fetch data: ', err);
    //                 this.setState({ error: true, loading: false });
    //             });
    //     } else if (activeRole === FACULTY_ADMIN) {
    //         axios.all([fetchOrganizationalUnits(), this.fetchLeaseholders()])
    //             .then(axios.spread((organizationalUnitsRes, leaseholderRes) => {
    //                 const organizationalUnits = organizationalUnitsRes.data.map((el) => ({
    //                     ...el, key: el.id, value: el.id, text: el.name
    //                 }));
    //                 const physicalLeaseholders = leaseholderRes.data.responseList.filter(el => el.entityType.id === 1);
    //                 const legalLeaseholders = leaseholderRes.data.responseList.filter(el => el.entityType.id === 2);
    //                 const organizationalUnitLeaseholders = leaseholderRes.data.responseList.filter(el => el.entityType.id === 3);
    //                 let totalPages = parseInt(leaseholderRes.data.total / resultsPerPage, 10);
    //                 totalPages += leaseholderRes.data.total % resultsPerPage !== 0 ? 1 : 0;
    //                 this.setState({
    //                     organizationalUnits,
    //                     physicalLeaseholders,
    //                     legalLeaseholders,
    //                     organizationalUnitLeaseholders,
    //                     loading: false,
    //                     totalPages,
    //                 });
    //             }))
    //             .catch((err => {
    //                 this.setState({ error: true, loading: false });
    //                 console.log('Failed to fetch data.');
    //             }));
    //     }
    // }
    getWritePrivilege() {
        const { activeRole } = this.state;
        if (activeRole === FACULTY_ADMIN) {
            return true;
        }
        return false;
    }
    getOrganizationalUnitsPrivilege() {
        const { activeRole } = this.state;
        if (activeRole === ADMINISTRATOR || activeRole === UNIVERSITY || activeRole === UNIVERSITY_ADMIN) {
            return true;
        }
        return false;
    }
    onFilterData(leaseholderFilter) {
        const { activeRole, resultsPerPage } = this.state;
        let leaseholderFilterRequest = {
            ...leaseholderFilter,
            paginationDTO: {
                page: 0,
                resultsPerPage,
            },
        };
        if (activeRole === FACULTY_ADMIN || activeRole === FACULTY) {
            leaseholderFilterRequest = { ...leaseholderFilterRequest, organizationalUnit: this.state.organizationalUnitId };
        }
        console.log(leaseholderFilterRequest);
        axios.post('/assets/leaseholders/filter/', { ...leaseholderFilterRequest })
            .then(res => {
                const filteredPhysicalLeaseholders = res.data.responseList.filter(el => el.entityType.id === 1);
                const filteredLegalLeaseholders = res.data.responseList.filter(el => el.entityType.id === 2);
                const filteredOrganizationalUnitLeaseholders = res.data.responseList.filter(el => el.entityType.id === 3);
                let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);
                this.setState({
                    filteredPhysicalLeaseholders,
                    filteredLegalLeaseholders,
                    filteredOrganizationalUnitLeaseholders,
                    showFiltersOnButton: true,
                    showFilterMode: false,
                    activePage: 1,
                    totalPages,
                    filterRequestData: leaseholderFilterRequest,
                });
            })
            .catch(err => {
                toast('Došlo je do greške!');
                console.log('Error: Failed to fetch filter data\n', err);
            });
    }

    getPhysicalLeaseholders(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        let filterRequestData = {
            organizationalUnit: this.getOrganizationalUnitsPrivilege() ? null : this.state.organizationalUnitId,

            entityType: 1,
            physicalEntity: null,
            legalEntity: null,
        };
        const paginationDTO = {
            page,
            resultsPerPage,
            order: null,
            fieldName: null,
        };
        filterRequestData = { ...filterRequestData, paginationDTO };
        console.log(filterRequestData);
        axios.post('/assets/leaseholders/filter/', { ...filterRequestData })
            .then(res => {
                const physicalLeaseholders = res.data.responseList.filter(el => el.entityType.id === 1);
                let physicalTotalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);
                this.setState({
                    physicalLeaseholders,
                    physicalActivePage: page + 1,
                    physicalTotalPages,
                    physicalResultsPerPage: resultsPerPage,
                    loader: false
                });
            })
            .catch(err => {
                toast('Došlo je do greške!');
                console.log('Error: Failed to fetch filter data\n', err);
            });
    }

    getLegalLeaseholders(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        let filterRequestData = {
            organizationalUnit: this.getOrganizationalUnitsPrivilege() ? null : this.state.organizationalUnitId,

            entityType: 2,
            physicalEntity: null,
            legalEntity: null,
        };
        const paginationDTO = {
            page,
            resultsPerPage,
            order: null,
            fieldName: null,
        };
        filterRequestData = { ...filterRequestData, paginationDTO };
        console.log(filterRequestData);
        axios.post('/assets/leaseholders/filter/', { ...filterRequestData })
            .then(res => {
                const legalLeaseholders = res.data.responseList;
                let legalTotalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);
                this.setState({
                    legalLeaseholders,
                    legalActivePage: page + 1,
                    legalTotalPages,
                    legalResultsPerPage: resultsPerPage,
                    loader: false
                });
            })
            .catch(err => {
                toast('Došlo je do greške!');
                console.log('Error: Failed to fetch filter data\n', err);
            });
    }

    getOrganizationalUnitLeaseholders(page=0, resultsPerPage= DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        let filterRequestData = {
            organizationalUnit: this.getOrganizationalUnitsPrivilege() ? null : this.state.organizationalUnitId,

            entityType: 3,
            physicalEntity: null,
            legalEntity: null,
        };
        const paginationDTO = {
            page,
            resultsPerPage,
            order: null,
            fieldName: null,
        };
        filterRequestData = { ...filterRequestData, paginationDTO };
        console.log(filterRequestData);
        axios.post('/assets/leaseholders/filter/', { ...filterRequestData })
            .then(res => {
                const organizationalUnitLeaseholders = res.data.responseList;
                let organizationalUnitTotalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);
                this.setState({
                    organizationalUnitLeaseholders,
                    organizationalUnitActivePage: page + 1,
                    organizationalUnitTotalPages,
                    organizationalUnitResultsPerPage: resultsPerPage,
                    loader: false
                });
            })
            .catch(err => {
                toast('Došlo je do greške!');
                console.log('Error: Failed to fetch filter data\n', err);
            });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            const filterData = {
                physicalLeaseholders: this.state.filteredPhysicalLeaseholders,
                legalLeaseholders: this.state.filteredLegalLeaseholders,
                organizationalUnitLeaseholders: this.state.filteredOrganizationalUnitLeaseholders,
            };
            return filterData;
        }
        const data = {
            physicalLeaseholders: this.state.physicalLeaseholders,
            legalLeaseholders: this.state.legalLeaseholders,
            organizationalUnitLeaseholders: this.state.organizationalUnitLeaseholders,
        };
        return data;
    }
    fetchOrganizationalUnits() {
        axios.all([fetchOrganizationalUnits(), fetchEntityTypes()])
            .then(axios.spread((organizationalUnitsRes, entityTypesRes) => {
                const organizationalUnits = organizationalUnitsRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name,
                }));
                const entityTypes = entityTypesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name,
                }));
                const lookups = {
                    entityTypes,
                };
                this.setState({
                    organizationalUnits,
                    entityTypes,
                    lookups,
                    loader: false,
                });
            }))
            .catch(err => {
                this.setState({ error: true, loader: false });
                console.log('Failed to fetch data.');
            });
    }
    // fetchLeaseholders(organizationalUnitId) {
    //     axios.get(`/assets/leaseholders/by-organizational-unit/${organizationalUnitId}`)
    //         .then(res => {
    // const physicalLeaseholders = res.data.filter(el => el.entityType.id === 1);
    // const legalLeaseholders = res.data.filter(el => el.entityType.id === 2);
    // const organizationalUnitLeaseholders = res.data.filter(el => el.entityType.id === 3);
    //
    //             this.setState({
    // physicalLeaseholders,
    // legalLeaseholders,
    // organizationalUnitLeaseholders
    //             });
    //         })
    //         .catch(err => {
    //             toast('Došlo je do greške!');
    //             console.log('Greska!');
    //         });
    // }
    activateEditRequest(el) {
        this.populateValues(el, 'edit');
    }
    activateContactRequest(el) {
        this.populateValues(el, 'contact');
    }
    activateAddressRequest(el) {
        this.populateValues(el, 'address');
    }
    activateAddRequest() {
        this.resetValues();
        this.setState({ entityType: 1 });
        this.setState({
            requestMode: 'add',
        });
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    cancelRequest() {
        this.setState({ requestMode: null });
        this.resetValues();
    }
    activateFilter() {
        this.setState({ showFilterMode: !this.state.showFilterMode });
    }
    filtersOff() {
        this.getLeaseholders(0, this.state.resultsPerPage);
        this.setState({
            showFilterMode: false,
            showFiltersOnButton: false,
        });
    }
    switchContactEditMode() {
        this.setState(prevState => ({ contactEditMode: !prevState.contactEditMode }));
    }
    onDeleteContact(contactId) {
        console.log('Pozvano delete Contact');
    }
    onEditContact(requestBody) {
        console.log('Pozvano edit Contact');
    }
    onAddNewContact(contact) {
        const contactRequest = {
            leaseholder: { id: this.state.entityId },
            contactType: contact.contactType,
            comment: contact.comment,
            value: contact.value,
        };
        axios.post('/assets/leaseholder-contacts/', { ...contactRequest })
            .then((res) => {
                console.log('Uspjesno: ', res.data);
                axios.all([this.fetchLeaseholderContacts(this.state.entityId)])
                    .then(axios.spread((leaseholderContactsRes) => {
                        const leaseholderData = {
                            addresses: this.state.leaseholderData.addresses,
                            contacts: leaseholderContactsRes.data,
                        };
                        this.setState({
                            leaseholderData,
                        });
                        toast('Uspješno dodan kontakt!');
                    }))
                    .catch(err => {
                        console.log('Error: ', err);
                    });
            })
            .catch((err) => {
                console.log('Error: ', err);
            });
    }
    updateContacts() {
        console.log('Pozvano update contacts');
    }
    switchAddressEditMode() {
        this.setState(prevState => ({ addressEditMode: !prevState.addressEditMode }));
    }
    onDeleteAddress(addressId) {
        console.log('Pozvano delete Contact');
    }
    onEditAddress(requestBody) {
        console.log('Pozvano edit Contact');
    }
    onAddNewAddress(address) {
        const place = {
            name: address.place,
            municipality: address.municipality,
            canton: address.canton,
            entity: address.entity,
            country: address.country,
        };
        const addressRequest = {
            leaseholder: { id: this.state.entityId },
            place,
            street: address.street,
        };
        console.log(addressRequest);
        axios.post('/assets/leaseholder-addresses/', { ...addressRequest })
            .then((res) => {
                console.log('Uspjesno: ', res.data);
                axios.all([this.fetchLeaseholderAddresses(this.state.entityId)])
                    .then(axios.spread((leaseholderAddressesRes) => {
                        const leaseholderData = {
                            addresses: leaseholderAddressesRes.data,
                            contacts: this.state.leaseholderData.contacts,
                        };
                        this.setState({
                            leaseholderData,
                        });
                    }))
                    .catch(err => {
                        console.log('Error: ', err);
                    });
                toast('Uspješno dodana adresa!');
            })
            .catch((err) => {
                console.log('Error: ', err);
            });
    }
    updateAddresses() {
        console.log('Pozvano update contacts');
    }
    resetValues() {
        this.setState({
            physicalEntityName: null,
            physicalEntityLastName: null,
            physicalEntityJMBG: null,
            comment: null,
            legalEntityName: null,
            legalEntityIdNumber: null,
            organizationalUnitEntity: null,
            entityType: null,
            entityId: null,
            entityOptLock: null,
            organizationalUnitError: false,
            physicalEntityNameError: false,
            physicalEntityLastNameError: false,
            physicalEntityJMBGError: false,
            legalEntityNameError: false,
            legalEntityIdNumberError: false,
            organizationalUnitEntityError: false,
        });
        const { activeRole } = this.state;
        if (activeRole === ADMINISTRATOR || activeRole === UNIVERSITY || activeRole === UNIVERSITY_ADMIN) {
            this.setState({ organizationalUnitId: null });
        }
    }
    fetchLeaseholderAddresses(entityId) {
        return axios.get(`/assets/leaseholder-addresses/by-leaseholder/${entityId}/`);
    }
    fetchLeaseholderContacts(entityId) {
        return axios.get(`/assets/leaseholder-contacts/by-leaseholder/${entityId}/`);
    }
    populateValues(el, mode) {
        console.log(el);
        if (el.entityType.id === 1) {
            this.setState({
                entityType: el.entityType.id,
                entityId: el.id,
                entityOptLock: el.optLock,
                comment: el.comment,
                physicalEntityName: el.physicalEntity.firstName,
                physicalEntityLastName: el.physicalEntity.lastName,
                physicalEntityJMBG: el.physicalEntity.jmbg,
                physicalEntityId: el.physicalEntity.id,
                physicalEntityOptLock: el.physicalEntity.optLock,
            });
        } else if (el.entityType.id === 2) {
            this.setState({
                entityType: el.entityType.id,
                entityId: el.id,
                entityOptLock: el.optLock,
                comment: el.comment,
                legalEntityName: el.legalEntity.name,
                legalEntityIdNumber: el.legalEntity.idNumber,
                legalEntityId: el.legalEntity.id,
                legalEntityOptLock: el.legalEntity.optLock,
            });
        } else if (el.entityType.id === 3) {
            this.setState({
                entityType: el.entityType.id,
                entityId: el.id,
                entityOptLock: el.optLock,
                comment: el.comment,
                organizationalUnitEntity: el.organizationalUnitLeaseholder.id,
            });
        }
        const { activeRole } = this.state;
        if (activeRole === UNIVERSITY || activeRole === UNIVERSITY_ADMIN) {
            this.setState({
                organizationalUnitId: el.organizationalUnit.id,
            });
        }
        axios.all([this.fetchLeaseholderAddresses(el.id), this.fetchLeaseholderContacts(el.id)])
            .then(axios.spread((leaseholderAddressesRes, leaseholderContactsRes) => {
                const leaseholderData = {
                    addresses: leaseholderAddressesRes.data,
                    contacts: leaseholderContactsRes.data,
                };
                this.setState({
                    leaseholderData,
                    requestMode: mode,
                    organizationalUnitError: false,
                    physicalEntityNameError: false,
                    physicalEntityLastNameError: false,
                    physicalEntityJMBGError: false,
                    legalEntityNameError: false,
                    legalEntityIdNumberError: false,
                    organizationalUnitEntityError: false,
                });
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }))
            .catch(err => {
                console.log('Error: ', err);
                toast('Greška prilikom dobivanja adrese i kontakta zakupca!');
                this.resetValues();
            });
    }
    sendPhysicalLeaseholderRequest() {
        const {
            physicalEntityName,
            physicalEntityLastName,
            physicalEntityJMBG,
            legalEntityName,
            legalEntityIdNumber,
            organizationalUnitEntity,
            entityType,
            organizationalUnitId,
        } = this.state;
        if (organizationalUnitId === null ||
            (physicalEntityName === null && entityType === 1) || (physicalEntityLastName === null && entityType === 1) ||
            (physicalEntityJMBG === null && entityType === 1)) {
            this.setState({
                organizationalUnitError: organizationalUnitId === null,
                physicalEntityNameError: (physicalEntityName === null && entityType === 1),
                physicalEntityLastNameError: (physicalEntityLastName === null && entityType === 1),
                physicalEntityJMBGError: (physicalEntityJMBG === null && entityType === 1),
                legalEntityNameError: (legalEntityName === null && entityType === 2),
                legalEntityIdNumberError: (legalEntityIdNumber === null && entityType === 2),
                organizationalUnitEntityError: (organizationalUnitEntity === null && entityType === 3),
            });
            toast('Nisu sva potrebna polja popunjena!');
            return;
        }
        const physicalEntityLeaseholder = {
            entityType: { id: 1 },
            physicalEntity: {
                firstName: this.state.physicalEntityName === '' ? null : this.state.physicalEntityName,
                lastName: this.state.physicalEntityLastName === '' ? null : this.state.physicalEntityLastName,
                jmbg: this.state.physicalEntityJMBG === '' ? null : this.state.physicalEntityJMBG,
            },
            legalEntity: null,
            organizationalUnitLeaseholder: null,
            organizationalUnit: this.state.organizationalUnitId ? { id: this.state.organizationalUnitId } : null,
            comment: this.state.comment ? this.state.comment : '',
        };
        if (this.state.requestMode === 'add') {
            axios.post('/assets/leaseholders/', { ...physicalEntityLeaseholder })
                .then(res => {
                    this.getPhysicalLeaseholders(this.state.physicalActivePage - 1, this.state.physicalResultsPerPage);
                    toast('Zahtjev uspješno poslan!');
                    this.setState({ requestMode: null });
                    this.resetValues();
                })
                .catch(err => {
                    console.log(err);
                    toast('Došlo je do greške!');
                });
        } else if (this.state.requestMode === 'edit') {
            const physicalEntityPut = {
                firstName: this.state.physicalEntityName,
                lastName: this.state.physicalEntityLastName,
                jmbg: this.state.physicalEntityJMBG,
                id: this.state.physicalEntityId,
                optLock: this.state.physicalEntityOptLock,
            };
            axios.put('/assets/physical-entities/', { ...physicalEntityPut })
                .then(response => {
                    const physicalEntityLeaseholderPut = {
                        entityType: { id: 1 },
                        physicalEntity: {
                            id: this.state.physicalEntityId,
                        },
                        legalEntity: null,
                        organizationalUnitLeaseholder: null,
                        organizationalUnit: this.state.organizationalUnitId ? { id: this.state.organizationalUnitId } : null,
                        comment: this.state.comment ? this.state.comment : '',
                        id: this.state.entityId,
                        optLock: this.state.entityOptLock
                    };
                    console.log(physicalEntityLeaseholderPut);
                    axios.put('/assets/leaseholders/', { ...physicalEntityLeaseholderPut })
                        .then(res => {
                            this.getPhysicalLeaseholders(this.state.physicalActivePage - 1, this.state.physicalResultsPerPage);
                            toast('Zahtjev uspješno uređen!');
                            this.setState({ requestMode: null });
                            this.resetValues();
                        })
                        .catch(err => {
                            console.log(err);
                            toast('Došlo je do greške!');
                        });
                })
                .catch(err => {
                    console.log(err);
                    toast('Došlo je do greške!');
                });
        }
    }
    sendLegalLeaseholderRequest() {
        const {
            physicalEntityName,
            physicalEntityLastName,
            physicalEntityJMBG,
            legalEntityName,
            legalEntityIdNumber,
            organizationalUnitEntity,
            entityType,
            organizationalUnitId,
        } = this.state;
        if (organizationalUnitId === null ||
            (legalEntityName === null && entityType === 2) ||
            (legalEntityIdNumber === null && entityType === 2)) {
            this.setState({
                organizationalUnitError: organizationalUnitId === null,
                physicalEntityNameError: (physicalEntityName === null && entityType === 1),
                physicalEntityLastNameError: (physicalEntityLastName === null && entityType === 1),
                physicalEntityJMBGError: (physicalEntityJMBG === null && entityType === 1),
                legalEntityNameError: (legalEntityName === null && entityType === 2),
                legalEntityIdNumberError: (legalEntityIdNumber === null && entityType === 2),
                organizationalUnitEntityError: (organizationalUnitEntity === null && entityType === 3),
            });
            toast('Nisu sva potrebna polja popunjena!');
            return;
        }
        const legalEntityLeaseholder = {
            entityType: { id: 2 },
            physicalEntity: null,
            legalEntity: {
                name: this.state.legalEntityName,
                idNumber: this.state.legalEntityIdNumber
            },
            organizationalUnitLeaseholder: null,
            organizationalUnit: this.state.organizationalUnitId ? { id: this.state.organizationalUnitId } : null,
            comment: this.state.comment ? this.state.comment : '',
        };
        if (this.state.requestMode === 'add') {
            axios.post('/assets/leaseholders/', { ...legalEntityLeaseholder })
                .then(res => {
                    this.getLegalLeaseholders(this.state.legalActivePage - 1, this.state.legalResultsPerPage);
                    toast('Zahtjev uspješno poslan!');
                    this.setState({ requestMode: null });
                    this.resetValues();
                })
                .catch(err => {
                    console.log(err);
                    toast('Došlo je do greške!');
                });
        } else if (this.state.requestMode === 'edit') {
            const legalEntityPut = {
                name: this.state.legalEntityName,
                idNumber: this.state.legalEntityIdNumber,
                id: this.state.legalEntityId,
                optLock: this.state.legalEntityOptLock,
            };
            axios.put('/assets/legal-entities/', { ...legalEntityPut })
                .then(response => {
                    const legalEntityLeaseholderPut = {
                        entityType: { id: 2 },
                        physicalEntity: null,
                        legalEntity: {
                            id: this.state.legalEntityId,
                        },
                        organizationalUnitLeaseholder: null,
                        organizationalUnit: this.state.organizationalUnitId ? { id: this.state.organizationalUnitId } : null,
                        comment: this.state.comment ? this.state.comment : '',
                        id: this.state.entityId,
                        optLock: this.state.entityOptLock
                    };
                    console.log(legalEntityLeaseholder);
                    axios.put('/assets/leaseholders/', { ...legalEntityLeaseholderPut })
                        .then(res => {
                            this.getLegalLeaseholders(this.state.legalActivePage - 1, this.state.legalResultsPerPage);
                            toast('Zahtjev uspješno uređen!');
                            this.setState({ requestMode: null });
                            this.resetValues();
                        })
                        .catch(err => {
                            console.log(err);
                            toast('Došlo je do greške!');
                        });
                })
                .catch(err => {
                    console.log(err);
                    toast('Došlo je do greške!');
                });
        }
    }
    sendOrganizationalUnitLeaseholderRequest() {
        const {
            physicalEntityName,
            physicalEntityLastName,
            physicalEntityJMBG,
            legalEntityName,
            legalEntityIdNumber,
            organizationalUnitEntity,
            entityType,
            organizationalUnitId,
        } = this.state;
        if (organizationalUnitId === null ||
            (organizationalUnitEntity === null && entityType === 3)) {
            this.setState({
                organizationalUnitError: organizationalUnitId === null,
                physicalEntityNameError: (physicalEntityName === null && entityType === 1),
                physicalEntityLastNameError: (physicalEntityLastName === null && entityType === 1),
                physicalEntityJMBGError: (physicalEntityJMBG === null && entityType === 1),
                legalEntityNameError: (legalEntityName === null && entityType === 2),
                legalEntityIdNumberError: (legalEntityIdNumber === null && entityType === 2),
                organizationalUnitEntityError: (organizationalUnitEntity === null && entityType === 3),
            });
            toast('Nisu sva potrebna polja popunjena!');
            return;
        }
        const organizationalUnitLeaseholder = {
            entityType: { id: 3 },
            physicalEntity: null,
            legalEntity: null,
            organizationalUnitLeaseholder: { id: this.state.organizationalUnitEntity },
            organizationalUnit: this.state.organizationalUnitId ? { id: this.state.organizationalUnitId } : null,
            comment: this.state.comment ? this.state.comment : '',
        };
        if (this.state.requestMode === 'add') {
            axios.post('/assets/leaseholders/', { ...organizationalUnitLeaseholder })
                .then(res => {
                    this.getOrganizationalUnitLeaseholders(this.state.organizationalUnitActivePage - 1, this.state.organizationalUnitResultsPerPage);
                    toast('Zahtjev uspješno poslan!');
                    this.setState({ requestMode: null });
                    this.resetValues();
                })
                .catch(err => {
                    console.log(err);
                    toast('Došlo je do greške!');
                });
        } else if (this.state.requestMode === 'edit') {
            const organizationalUnitLeaseholderPut = {
                ...organizationalUnitLeaseholder,
                id: this.state.entityId,
                optLock: this.state.entityOptLock
            };
            console.log(organizationalUnitLeaseholderPut);
            axios.put('/assets/leaseholders/', { ...organizationalUnitLeaseholderPut })
                .then(res => {
                    this.getOrganizationalUnitLeaseholders(this.state.organizationalUnitActivePage - 1, this.state.organizationalUnitResultsPerPage);
                    toast('Zahtjev uspješno uređen!');
                    this.setState({ requestMode: null });
                    this.resetValues();
                })
                .catch(err => {
                    console.log(err);
                    toast('Došlo je do greške!');
                });
        }
    }
    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value !== '' ? value : null,
        });
    }
    switchToDetails(leaseholder) {
        console.log(leaseholder);
        if (leaseholder !== null) {
            axios.all([this.fetchLeaseholderAddresses(leaseholder.id), this.fetchLeaseholderContacts(leaseholder.id)])
                .then(axios.spread((leaseholderAddressesRes, leaseholderContactsRes) => {
                    const leaseholderData = {
                        addresses: leaseholderAddressesRes.data,
                        contacts: leaseholderContactsRes.data,
                    };
                    this.setState({
                        leaseholderData,
                        details: true,
                        leaseholderObject: leaseholder,
                    });
                }))
                .catch(err => {
                    toast('Greška prilikom dobivanja adrese i kontakta zakupca!');
                    console.log('Error: ', err);
                });
        }
    }
    switchToTable() {
        this.setState({
            leaseholderObject: null,
            details: false,
        });
    }
    handlePageChange(e, { activePage }) {
        console.log('Page changed: ', activePage);
        if (activePage === this.state.activePage) {
            return;
        }
        if (this.state.showFiltersOnButton) {
            this.getFilteredLeaseholders(activePage - 1, this.state.resultsPerPage);
        } else {
            this.getLeaseholders(activePage - 1, this.state.resultsPerPage);
        }
    }

    handlePhysicalPageChange(e, { activePage }) {
        if (activePage === this.state.physicalActivePage) {
            return;
        }
        this.getPhysicalLeaseholders(activePage - 1, this.state.resultsPerPage);
    }

    handleLegalPageChange(e, { activePage }) {
        if (activePage === this.state.legalActivePage) {
            return;
        }
        this.getLegalLeaseholders(activePage - 1, this.state.resultsPerPage);
    }

    handleOrganizationalUnitPageChange(e, { activePage }) {
        if (activePage === this.state.organizationalUnitActivePage) {
            return;
        }
        this.getOrganizationalUnitLeaseholders(activePage - 1, this.state.resultsPerPage);
    }

    handleResultsPerPageChange(e, { value }) {
        if (this.state.showFiltersOnButton) {
            this.getFilteredLeaseholders(0, value);
            return;
        }
        this.getLeaseholders(0, value);
    }

    handleTabChange = (e, { activeIndex }) => this.setState({ activeIndex, requestMode: null });

    render() {
        const panes = [
            {
                menuItem: 'Fizička lica',
                render: () => (<Tab.Pane attached={false} as={Responsive}>{
                    this.state.loader?
                        <Loader active inline="centered" />
                        :
                    physicalLeaseholders.length ?
                    <React.Fragment>
                        <Table celled selectable>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Ime i prezime</Table.HeaderCell>
                                    <Table.HeaderCell>Jedinstveni matični broj</Table.HeaderCell>
                                    <Table.HeaderCell>Napomena</Table.HeaderCell>
                                    {writePrivilege &&
                                    <Table.HeaderCell></Table.HeaderCell>
                                    }
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {physicalLeaseholders.map(el =>
                                    (
                                        <Table.Row key={el.id}>
                                            <Table.Cell onClick={() => this.switchToDetails(el)}>{el.physicalEntity.firstName} {el.physicalEntity.lastName}</Table.Cell>
                                            <Table.Cell onClick={() => this.switchToDetails(el)}>{el.physicalEntity.jmbg}</Table.Cell>
                                            <Table.Cell onClick={() => this.switchToDetails(el)}>{el.comment}</Table.Cell>
                                            {writePrivilege &&
                                            <Table.Cell verticalAlign="middle" className="text-center" >
                                                <Popup
                                                    content="Adresa"
                                                    position="top center"
                                                    trigger={

                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="marker"
                                                            size="tiny"
                                                            color="orange"
                                                            onClick={() => {
                                                                this.activateAddressRequest(el);
                                                            }}
                                                        />

                                                    }
                                                />
                                                <Popup
                                                    content="Kontakt"
                                                    position="top center"
                                                    trigger={

                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="phone"
                                                            size="tiny"
                                                            color="blue"
                                                            onClick={() => {
                                                                this.activateContactRequest(el);
                                                            }}
                                                        />

                                                    }
                                                />
                                                <Popup
                                                    content="Izmjena"
                                                    position="top center"
                                                    trigger={

                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="pencil"
                                                            size="tiny"
                                                            color="green"

                                                            onClick={() => {
                                                                this.activateEditRequest(el);
                                                            }}
                                                        />

                                                    }
                                                />
                                                <Popup
                                                    content="Brisanje"
                                                    position="top center"
                                                    trigger={

                                                        <Button
                                                            basic="true"
                                                            circular
                                                            disabled
                                                            icon="close"
                                                            size="tiny"
                                                            color="red"
                                                            onClick={() => {

                                                            }}
                                                        />

                                                    }
                                                />
                                            </Table.Cell>
                                            }
                                        </Table.Row>
                                    ))
                                }
                            </Table.Body>
                        </Table>
                        {/*<PaginationSegment*/}
                        {/*    activePage={this.state.physicalActivePage}*/}
                        {/*    totalPages={this.state.physicalTotalPages}*/}
                        {/*    onPageChange={this.handlePhysicalPageChange}*/}
                        {/*/>*/}
                    </React.Fragment> :
                    <p>Nema podataka.</p>
                } </Tab.Pane>)
            },
            {
                menuItem: 'Pravna lica',
                render: () => (<Tab.Pane attached={false} as={Responsive}>{legalLeaseholders.length ?
                    <React.Fragment>
                        <Table celled selectable>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Naziv</Table.HeaderCell>
                                    <Table.HeaderCell>ID broj</Table.HeaderCell>
                                    <Table.HeaderCell>Napomena</Table.HeaderCell>
                                    {writePrivilege &&
                                    <Table.HeaderCell></Table.HeaderCell>
                                    }
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {legalLeaseholders.map(el =>
                                    (
                                        <Table.Row key={el.id}>
                                            <Table.Cell onClick={() => this.switchToDetails(el)}>{el.legalEntity.name}</Table.Cell>
                                            <Table.Cell onClick={() => this.switchToDetails(el)}>{el.legalEntity.idNumber}</Table.Cell>
                                            <Table.Cell onClick={() => this.switchToDetails(el)}>{el.comment}</Table.Cell>
                                            {writePrivilege &&
                                            <Table.Cell verticalAlign="middle" className="text-center" >
                                                <Popup
                                                    content="Adresa"
                                                    position="top center"
                                                    trigger={

                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="marker"
                                                            size="tiny"
                                                            color="orange"
                                                            onClick={() => {
                                                                this.activateAddressRequest(el);
                                                            }}
                                                        />

                                                    }
                                                />
                                                <Popup
                                                    content="Kontakt"
                                                    position="top center"
                                                    trigger={

                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="phone"
                                                            size="tiny"
                                                            color="blue"

                                                            onClick={() => {
                                                                this.activateContactRequest(el);
                                                            }}
                                                        />

                                                    }
                                                />
                                                <Popup
                                                    content="Izmjena"
                                                    position="top center"
                                                    trigger={

                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="pencil"
                                                            size="tiny"
                                                            color="green"
                                                            onClick={() => {
                                                                this.activateEditRequest(el);
                                                            }}
                                                        />

                                                    }
                                                />
                                                <Popup
                                                    content="Brisanje"
                                                    position="top center"
                                                    trigger={

                                                        <Button
                                                            basic="true"
                                                            circular
                                                            disabled
                                                            icon="close"
                                                            size="tiny"
                                                            color="red"
                                                            onClick={() => {

                                                            }}
                                                        />

                                                    }
                                            />
                                            </Table.Cell>
                                            }
                                        </Table.Row>
                                    ))
                                }
                            </Table.Body>
                        </Table>
                        {/*<PaginationSegment*/}
                        {/*    activePage={this.state.legalActivePage}*/}
                        {/*    totalPages={this.state.legalTotalPages}*/}
                        {/*    onPageChange={this.handleLegalPageChange}*/}
                        {/*/>*/}
                    </React.Fragment> :
                    <p>Nema podataka.</p>
                }</Tab.Pane>)
            },
            {
                menuItem: 'Organizacione jedinice',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    {organizationalUnitLeaseholders.length ?
                    <React.Fragment>
                        <Table celled selectable>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Naziv organizacione jedinice</Table.HeaderCell>
                                    <Table.HeaderCell>ID broj</Table.HeaderCell>
                                    <Table.HeaderCell>Napomena</Table.HeaderCell>
                                    {writePrivilege &&
                                    <Table.HeaderCell></Table.HeaderCell>
                                    }
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {organizationalUnitLeaseholders.map(el =>
                                    (
                                        <Table.Row key={el.id}>
                                            <Table.Cell onClick={() => this.switchToDetails(el)}>{el.organizationalUnitLeaseholder.name}</Table.Cell>
                                            <Table.Cell onClick={() => this.switchToDetails(el)}>{el.organizationalUnitLeaseholder.id}</Table.Cell>
                                            <Table.Cell onClick={() => this.switchToDetails(el)}>{el.comment}</Table.Cell>
                                            {writePrivilege &&
                                            <Table.Cell verticalAlign="middle" className="text-center" >

                                                <Popup
                                                    content="Adresa"
                                                    position="top center"
                                                    trigger={

                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="marker"
                                                            size="tiny"
                                                            color="orange"
                                                            onClick={() => {
                                                                this.activateAddressRequest(el);
                                                            }}
                                                        />

                                                    }
                                                />
                                                <Popup
                                                    content="Kontakt"
                                                    position="top center"
                                                    trigger={

                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="phone"
                                                            size="tiny"
                                                            color="blue"
                                                            onClick={() => {
                                                                this.activateContactRequest(el);
                                                            }}
                                                        />

                                                    }
                                                />
                                                <Popup
                                                    content="Izmjena"
                                                    position="top center"
                                                    trigger={

                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="pencil"
                                                            size="tiny"
                                                            color="green"
                                                            onClick={() => {
                                                                this.activateEditRequest(el);
                                                            }}
                                                        />

                                                    }
                                                />
                                                <Popup
                                                    content="Brisanje"
                                                    position="top center"
                                                    trigger={

                                                        <Button
                                                            basic="true"
                                                            circular
                                                            disabled
                                                            icon="close"
                                                            size="tiny"
                                                            color="red"
                                                            onClick={() => {

                                                            }}
                                                        />

                                                    }
                                                    />

                                                        </Table.Cell>
                                            }
                                        </Table.Row>
                                    ))
                                }
                            </Table.Body>
                        </Table>
                        {/*<PaginationSegment*/}
                        {/*    activePage={this.state.organizationalUnitActivePage}*/}
                        {/*    totalPages={this.state.organizationalUnitTotalPages}*/}
                        {/*    onPageChange={this.handleOrganizationalUnitPageChange}*/}
                        {/*/>*/}
                    </React.Fragment> :
                    <p>Nema podataka.</p>
                }</Tab.Pane>)
            },
        ];
        const organizationalUnitPrivilege = this.getOrganizationalUnitsPrivilege();
        const writePrivilege = this.getWritePrivilege();
        const {
            leaseholderObject,
            details,
            leaseholderData
        } = this.state;
        const data = this.getDataToRender();
        const { physicalLeaseholders, legalLeaseholders, organizationalUnitLeaseholders } = data;
        if (details) {
            return (<LeaseholderDetails
                leaseholder={leaseholderObject}
                addresses={leaseholderData.addresses}
                contacts={leaseholderData.contacts}
                switchToTable={this.switchToTable}
            />);
        }
        return (
            <div>
                <Header as="h1">Zakupci</Header>
                { // <Segment.Group raised>
                    //     <Segment>
                    //         <Form>
                    // <Form.Group>
                    //     <Form.Dropdown clearable
                    //         label="Organizaciona jedinica"
                    //         placeholder="Organizaciona jedinica"
                    //         value={this.state.organizationalUnitId}
                    //         onChange={this.handleInputChange}
                    //         name="organizationalUnitId"
                    //         options={this.state.organizationalUnits}
                    //         search
                    //         fluid
                    //     />
                    //     <Button
                    //         type="submit"
                    //         onClick={() => this.fetchLeaseholders(this.state.organizationalUnitId)}
                    //     >Pretraga
                    //     </Button>
                    // </Form.Group>
                    //         </Form>
                    //     </Segment>
                    // </Segment.Group>
                }
                {
                    (this.state.requestMode === 'edit' || this.state.requestMode === 'add') &&

                    <Segment.Group raised >
                        <Segment raised>
                            <Header as="h3">
                                {this.state.requestMode === 'add' ? 'Dodavanje novog zakupca' : 'Uređivanje zakupaca'}
                            </Header>
                        </Segment>
                        <Segment>
                            <Form noValidate>
                                <Form.Group widths="equal">
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Izaberite tip zakupca"
                                        value={this.state.entityType}
                                        onChange={this.handleInputChange}
                                        name="entityType"
                                        options={this.state.entityTypes}
                                        search
                                        fluid
                                        selection
                                        required
                                    />
                                    <Form.Field />
                                    <Form.Field />
                                    <Form.Field />
                                </Form.Group>
                            </Form>

                        </Segment>
                        <Segment raised clearing>
                            {this.state.requestMode === 'add' &&
                            <Form noValidate>
                                {organizationalUnitPrivilege &&
                                <Form.Group>
                                    <Form.Dropdown
                                        clearable
                                        label="Organizaciona jedinica"
                                        placeholder="Organizaciona jedinica"
                                        value={this.state.organizationalUnitId}
                                        onChange={this.handleInputChange}
                                        name="organizationalUnitId"
                                        options={this.state.organizationalUnits}
                                        search
                                        fluid
                                        required
                                        selection
                                        error={this.state.organizationalUnitError}
                                    />
                                </Form.Group>
                                }

                            </Form>
                            }
                            {(this.state.entityType === 1) &&
                            <Form noValidate>
                                <Form.Group widths="equal">
                                    <Form.Field
                                        label="Ime"
                                        control={Input}
                                        name="physicalEntityName"
                                        value={this.state.physicalEntityName}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite ime"
                                        required
                                        error={this.state.physicalEntityNameError}
                                    />
                                    <Form.Field
                                        label="Prezime"
                                        control={Input}
                                        name="physicalEntityLastName"
                                        value={this.state.physicalEntityLastName}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite prezime"
                                        required
                                        error={this.state.physicalEntityLastNameError}
                                    />
                                    <Form.Field
                                        label="JMBG"
                                        control={Input}
                                        name="physicalEntityJMBG"
                                        value={this.state.physicalEntityJMBG}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite JMBG"
                                        required
                                        error={this.state.physicalEntityJMBGError}
                                    />
                                    <Form.Field
                                        label="Napomena"
                                        control={Input}
                                        name="comment"
                                        value={this.state.comment}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite napomenu"
                                    />
                                </Form.Group>

                                <Button
                                    floated="right"
                                    onClick={this.cancelRequest}
                                    basic
                                    color="blue"
                                >Odustani</Button>
                                <Button
                                    floated="right"
                                    color="blue"
                                    onClick={
                                        () => {
                                            this.sendPhysicalLeaseholderRequest();
                                        }
                                    }
                                >
                                    {this.state.requestMode === 'add' ? 'Pošalji' : 'Uredi'}
                                </Button>
                            </Form>
                            }
                            {(this.state.entityType === 2) &&
                            <Form noValidate>
                                <Form.Group widths="equal">
                                    <Form.Field
                                        label="Naziv"
                                        control={Input}
                                        name="legalEntityName"
                                        value={this.state.legalEntityName}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite naziv"
                                        required
                                        error={this.state.legalEntityNameError}
                                    />
                                    <Form.Field
                                        label="ID"
                                        control={Input}
                                        name="legalEntityIdNumber"
                                        value={this.state.legalEntityIdNumber}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite naziv"
                                        required
                                        error={this.state.legalEntityIdNumberError}
                                    />
                                    <Form.Field
                                        label="Napomena"
                                        control={Input}
                                        name="comment"
                                        value={this.state.comment}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite napomenu"
                                    />
                                    <Form.Field></Form.Field>
                                </Form.Group>

                                <Button
                                    floated="right"
                                    onClick={this.cancelRequest}
                                    basic
                                    color="blue"
                                >Odustani</Button>
                                <Button
                                    floated="right"
                                    color="blue"
                                    onClick={
                                        () => {
                                            this.sendLegalLeaseholderRequest();
                                        }
                                    }
                                >
                                    {this.state.requestMode === 'add' ? 'Pošalji' : 'Uredi'}
                                </Button>
                            </Form>
                            }
                            {(this.state.entityType === 3) &&
                            <Form noValidate>
                                <Form.Group widths="equal">
                                    <Form.Dropdown
                                        clearable
                                        label="Organizaciona jedinica"
                                        placeholder="Organizaciona jedinica"
                                        value={this.state.organizationalUnitEntity}
                                        onChange={this.handleInputChange}
                                        name="organizationalUnitEntity"
                                        options={this.state.organizationalUnits}
                                        search
                                        fluid
                                        required
                                        selection
                                        error={this.state.organizationalUnitEntityError}
                                    />
                                    <Form.Field
                                        label="Napomena"
                                        control={Input}
                                        name="comment"
                                        value={this.state.comment}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite napomenu"
                                    />
                                    <Form.Field></Form.Field>
                                    <Form.Field></Form.Field>
                                </Form.Group>

                                <Button
                                    floated="right"
                                    onClick={this.cancelRequest}
                                    basic
                                    color="blue"
                                >Odustani</Button>
                                <Button
                                    floated="right"
                                    color="blue"
                                    onClick={
                                        () => {
                                            this.sendOrganizationalUnitLeaseholderRequest();
                                        }
                                    }
                                >
                                    {this.state.requestMode === 'add' ? 'Pošalji' : 'Uredi'}
                                </Button>
                            </Form>
                            }
                        </Segment>
                    </Segment.Group>}
                    {this.state.requestMode === 'contact' &&


                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3">
                                        Kontakti
                                    <Header style={IconHeader} floated="right">
                                        {/*<Popup*/}
                                        {/*    trigger={*/}
                                        {/*        <Icon*/}
                                        {/*            style={FiltersOnStyle}*/}
                                        {/*            link*/}
                                        {/*            size={'mini'}*/}
                                        {/*            circular*/}
                                        {/*            basic*/}
                                        {/*            color={!this.state.contactEditMode ? 'blue' : 'red'}*/}
                                        {/*            floated="right"*/}
                                        {/*            name={!this.state.contactEditMode ? 'add' : 'close'}*/}
                                        {/*            onClick={this.switchContactEditMode}*/}
                                        {/*        />*/}

                                        {/*    }*/}
                                        {/*    content={!this.state.contactEditMode ? "Dodaj kontakt" : "Zatvori formu"}*/}
                                        {/*    hideOnScroll*/}
                                        {/*    position="top center"*/}
                                        {/*/>*/}

                                                <Icon
                                                    style={FiltersOnStyle}
                                                />

                                        <Popup
                                            trigger={
                                                <Icon
                                                    style={FiltersOnStyle}
                                                    link
                                                    size={'mini'}
                                                    circular
                                                    basic
                                                    floated="right"
                                                    name="close"
                                                    onClick={()=>{this.setState({requestMode: null})}}
                                                />
                                            }
                                            content="Zatvori"
                                            hideOnScroll
                                            position="top center"
                                        />
                                    </Header>

                                    <Header style={IconHeader} floated="right" >
                                        <Button
                                            basic
                                            color={!this.state.contactEditMode ? 'blue' : 'red'}
                                            size="small"
                                            style={FiltersOnStyle}
                                            onClick={this.switchContactEditMode}
                                        >
                                            {!this.state.contactEditMode ? 'Dodaj' : 'Odustani'}
                                        </Button>
                                    </Header>
                                </Header>
                            </Segment>
                            <LeaseholderContact
                                contacts={this.state.leaseholderData.contacts || []}
                                editMode={this.state.contactEditMode}
                                contactTypes={this.state.contactTypes}
                                onAddNewContact={this.onAddNewContact}
                                onDeleteContact={this.onDeleteContact}
                                onEditContact={this.onEditContact}
                            />
                        </Segment.Group>
                    }

                    {this.state.requestMode === 'address' &&

                        <Segment.Group raised>
                            <Segment clearing>
                                <Header as="h3">
                                        Adrese
                                    <Header style={IconHeader} floated="right" onClick={this.switchAddressEditMode}>
                                        <Button
                                            basic
                                            color="blue"
                                            size="small"

                                            style={RightHeaderWithButton}
                                            onClick={this.onNewSelection}
                                        >
                                            {!this.state.addressEditMode ? 'Dodaj' : 'Odustani'}
                                        </Button>
                                    </Header>
                                </Header>
                            </Segment>
                            <LeaseholderAddress
                                addresses={this.state.leaseholderData.addresses || []}
                                editMode={this.state.addressEditMode}
                                municipalities={this.state.municipalities}
                                cantons={this.state.cantons}
                                entities={this.state.entities}
                                countries={this.state.countries}
                                onAddNewAddress={this.onAddNewAddress}
                                onDeleteAddress={this.onDeleteAddress}
                                onEditAddress={this.onEditAddress}
                            />
                        </Segment.Group>

                    }


                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            Spisak zakupaca

                            <Header style={IconHeader} floated="right" >
                                {writePrivilege &&
                                    <Button
                                        floated="left"
                                        icon
                                        labelPosition="left"
                                        primary
                                        size="small"
                                        style={FiltersOnStyle}
                                        onClick={this.activateAddRequest}
                                    >
                                        <Icon className="add" />
                                        Dodavanje novog zakupca
                                    </Button>

                                }

                                {/* {this.state.showFiltersOnButton && */}
                                {/* <Button */}
                                {/*    floated="left" */}
                                {/*    icon */}
                                {/*    labelPosition="right" */}
                                {/*    color="orange" */}
                                {/*    size="small" */}
                                {/*    style={FiltersOnStyle} */}
                                {/* > */}
                                {/*    <Icon className="remove" onClick={this.filtersOff} /> */}
                                {/*    Filter uključen */}
                                {/* </Button>} */}
                                {/* <Icon /> */}
                                {/* <Popup */}
                                {/*    trigger={<Icon link circular basic floated="right" name="filter" onClick={this.activateFilter} />} */}
                                {/*    content="Filtriraj podatke" */}
                                {/*    hideOnScroll */}
                                {/*    position="top center" */}
                                {/* /> */}
                            </Header>
                        </Header>
                    </Segment>
                    {this.state.showFilterMode &&
                        <LeaseholderFilter
                            onFilterData={this.onFilterData}
                            lookups={this.state.lookups}
                            entityTypes={this.state.entityTypes}
                            organizationalUnits={this.state.organizationalUnits}
                            organizationalUnitPrivilege={organizationalUnitPrivilege}
                            cancelFilter={this.activateFilter}
                        />
                    }
                    <Segment>

                        <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} onTabChange={this.handleTabChange} />
                    </Segment>

                    {this.state.activeIndex === 0 && physicalLeaseholders.length>0 && <PaginationSegment
                        activePage={this.state.physicalActivePage}
                        totalPages={this.state.physicalTotalPages}
                        onPageChange={this.handlePhysicalPageChange}
                    />}
                    {this.state.activeIndex === 1 && legalLeaseholders.length>0 && <PaginationSegment
                        activePage={this.state.legalActivePage}
                        totalPages={this.state.legalTotalPages}
                        onPageChange={this.handleLegalPageChange}
                    />}
                    {this.state.activeIndex === 2 && organizationalUnitLeaseholders.length>0 && <PaginationSegment
                        activePage={this.state.organizationalUnitActivePage}
                        totalPages={this.state.organizationalUnitTotalPages}
                        onPageChange={this.handleOrganizationalUnitPageChange}
                    />}
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}
export default Leaseholder;



// WEBPACK FOOTER //
// ./src/views/Assets/Leaseholder.js